'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reactRouter = require('react-router');

var _calendar = require('./calendar');

var _calendar2 = _interopRequireDefault(_calendar);

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

var _doctifyUtils = require('doctify-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CoreRightSection = function CoreRightSection(_ref) {
    var hasBookings = _ref.hasBookings,
        availabilities = _ref.availabilities,
        availableFrom = _ref.availableFrom,
        nextAvailableAt = _ref.nextAvailableAt,
        profileUrl = _ref.profileUrl;
    return hasBookings && availabilities && availabilities.length && _react2.default.createElement(_calendar2.default, {
        availabilities: availabilities,
        nextAvailableAt: nextAvailableAt,
        profileUrl: profileUrl
    }) || _react2.default.createElement(
        'div',
        { className: _style2.default.requestAppointmentSpecialistButton },
        _react2.default.createElement(
            _reactRouter.Link,
            {
                to: profileUrl,
                className: 'btn solid',
                onClick: function onClick() {
                    (0, _doctifyUtils.fireGTMevent)(availableFrom ? 'patient_booking_calendar_button_srp_step1' : 'patient_lead_srp_click', '/specialist/' + profileUrl);
                },
                onlyActiveOnIndex: false
            },
            availableFrom && _react2.default.createElement('i', { className: 'ion-calendar' }) || _react2.default.createElement('i', { className: 'ion-android-mail' }),
            _react2.default.createElement(
                'span',
                null,
                availableFrom && 'Available: ' + new _moment2.default(availableFrom).format('ddd, MMM DD') || 'Request Appointment'
            )
        )
    );
};

CoreRightSection.defaultProps = {
    hasBookings: false,
    availabilities: [],
    availableFrom: new _moment2.default.utc(),
    profileUrl: ''
};

CoreRightSection.displayName = 'CoreRightSection';

exports.default = CoreRightSection;


// WEBPACK FOOTER //
// ./components/search-results/lib/components/core-right-section.js